// extracted by mini-css-extract-plugin
export var numpadContainer = "_lc-1";
export var phoneButton = "_lc-0";